<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiArrowDown } from "@mdi/js";
export default {
  name: "MdiArrowDown",
  data() {
    return {
      svgPath: mdiArrowDown,
    };
  },
};
</script>
